import changeItemStatus from './changeItemStatus'
import getItems from './getItems'

export const changeItemStatusPromise = changeItemStatus
export const getItemsPromise = getItems
